module.exports = __webpack_public_path__ + "img/LOGIN_MODERNO.144397c8.png";